import { render, staticRenderFns } from "./Evaluations.vue?vue&type=template&id=ccfbd51a&"
import script from "./Evaluations.vue?vue&type=script&lang=js&"
export * from "./Evaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports